/* PASHION — Roue de la chance (demi-roue façon jeu)
   window.PashionWheel.create(host, { segments: [{ key, label, dark }], hubLabel, hint, formId })
     → { spinTo(key) : Promise, reset() }
   window.PashionWheel.confetti(host) */
(function () {
  if (window.PashionWheel) return;
  var reduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);

  function esc(t) { return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function pt(a, r) { var t = a * Math.PI / 180; return (100 + r * Math.sin(t)).toFixed(2) + ' ' + (100 - r * Math.cos(t)).toFixed(2); }
  function segPath(i, step, r) { return 'M100 100 L' + pt(i * step - step / 2, r) + ' A' + r + ' ' + r + ' 0 0 1 ' + pt(i * step + step / 2, r) + ' Z'; }

  function create(host, o) {
    var segs = o.segments || [];
    var n = segs.length || 1, step = 360 / n, R = 89;
    var angle = 0, idleAnim = null, lightTimer = null, phase = 0, spinning = false;

    /* Segments */
    var rotor = '<svg viewBox="0 0 200 200" aria-hidden="true">';
    for (var i = 0; i < n; i++) {
      var s = segs[i], dark = !!s.dark;
      var lines = String(s.label || '').split('|');
      var fs = lines.length > 1 ? 9.5 : 14.5;
      var y = lines.length > 1 ? 28 : 31;
      rotor += '<g class="pw__seg" data-i="' + i + '">';
      rotor += '<path d="' + segPath(i, step, R) + '" fill="' + (dark ? '#141414' : '#f2f2f2') + '" stroke="#0a0a0a" stroke-width="1.2"/>';
      rotor += '<text transform="rotate(' + (i * step) + ' 100 100)" x="100" y="' + y + '" text-anchor="middle" fill="' + (dark ? '#f5f5f5' : '#0a0a0a') + '" style="font-family: var(--ppop-display, \'Bebas Neue\', Impact, sans-serif); font-size: ' + fs + 'px; letter-spacing: .03em;">';
      for (var j = 0; j < lines.length; j++) rotor += '<tspan x="100" dy="' + (j ? fs : 0) + '">' + esc(lines[j]) + '</tspan>';
      rotor += '</text></g>';
    }
    rotor += '<circle cx="100" cy="100" r="26" fill="#0a0a0a"/>';
    rotor += '<g class="pw__win"></g></svg>';

    /* Anneau + ampoules (fixes) */
    var lights = '<svg class="pw__lights" viewBox="0 0 200 200" aria-hidden="true">';
    lights += '<circle cx="100" cy="100" r="94.5" fill="none" stroke="#0a0a0a" stroke-width="11"/>';
    lights += '<circle cx="100" cy="100" r="89.5" fill="none" stroke="#f5f5f5" stroke-width="1.2"/>';
    lights += '<circle cx="100" cy="100" r="99.4" fill="none" stroke="#f5f5f5" stroke-width="1.2"/>';
    for (var b = 0; b < 32; b++) {
      var bp = pt(b * (360 / 32), 94.5).split(' ');
      lights += '<circle class="pw__bulb" cx="' + bp[0] + '" cy="' + bp[1] + '" r="2.2"/>';
    }
    lights += '</svg>';

    var pointer = '<div class="pw__pointer" aria-hidden="true"><svg viewBox="0 0 28 38"><path d="M14 36 L4 13 A11 11 0 1 1 24 13 Z" fill="#f5f5f5" stroke="#0a0a0a" stroke-width="2" stroke-linejoin="round"/><circle cx="14" cy="11" r="4" fill="#0a0a0a"/></svg></div>';
    var hub = '<button type="submit" class="pw__hub"' + (o.formId ? ' form="' + esc(o.formId) + '"' : '') + '>' + esc(o.hubLabel || 'Lancer') + '</button>';
    var hint = o.hint ? '<div class="pw__hint" aria-hidden="true">' + esc(o.hint) + '</div>' : '';

    host.classList.add('pw');
    host.innerHTML = '<div class="pw__stage"><div class="pw__rotor">' + rotor + '</div>' + lights + '<div class="pw__flash"></div><div class="pw__base"></div></div>' + pointer + hub + hint;

    var rotorEl = host.querySelector('.pw__rotor');
    var pointerEl = host.querySelector('.pw__pointer');
    var bulbs = host.querySelectorAll('.pw__bulb');
    var winLayer = host.querySelector('.pw__win');
    var canAnimate = typeof rotorEl.animate === 'function';

    function setLights(mode) {
      clearInterval(lightTimer);
      function paint(fn) { for (var k = 0; k < bulbs.length; k++) bulbs[k].classList.toggle('on', !!fn(k)); }
      if (mode === 'spin') lightTimer = setInterval(function () { phase++; paint(function (k) { return (k + phase) % 4 === 0; }); }, 55);
      else if (mode === 'win') lightTimer = setInterval(function () { phase++; paint(function () { return phase % 2 === 0; }); }, 170);
      else lightTimer = setInterval(function () { phase++; paint(function (k) { return (k + phase) % 2 === 0; }); }, 480);
    }

    function readAngle() {
      var tr = window.getComputedStyle(rotorEl).transform;
      if (!tr || tr === 'none') return angle;
      var m = tr.match(/matrix\(([^)]+)\)/);
      if (!m) return angle;
      var v = m[1].split(',').map(parseFloat);
      return Math.atan2(v[1], v[0]) * 180 / Math.PI;
    }

    function startIdle() {
      if (reduced || !canAnimate) return;
      idleAnim = rotorEl.animate(
        [{ transform: 'rotate(' + angle + 'deg)' }, { transform: 'rotate(' + (angle + 360) + 'deg)' }],
        { duration: 70000, iterations: Infinity }
      );
    }

    var lastFlick = 0, lastBuzz = 0;
    function flick() {
      var now = Date.now();
      if (now - lastFlick < 45) return;
      lastFlick = now;
      if (canAnimate) {
        pointerEl.animate(
          [{ transform: 'rotate(0deg)' }, { transform: 'rotate(-24deg)', offset: .3 }, { transform: 'rotate(0deg)' }],
          { duration: 160, easing: 'ease-out' }
        );
      }
      if (navigator.vibrate && now - lastBuzz > 70) { lastBuzz = now; try { navigator.vibrate(4); } catch (e) {} }
    }

    function win(i) {
      var g = host.querySelectorAll('.pw__seg');
      for (var k = 0; k < g.length; k++) g[k].classList.toggle('is-win', k === i);
      winLayer.innerHTML = '<path class="pw__winring" d="' + segPath(i, step, R - 2) + '"/>';
      host.classList.add('is-won');
      setLights('win');
    }

    function spinTo(key) {
      return new Promise(function (resolve) {
        if (spinning) return;
        spinning = true;
        var cur = readAngle();
        if (idleAnim) { idleAnim.cancel(); idleAnim = null; }
        rotorEl.style.transform = 'rotate(' + cur + 'deg)';

        var idx = [];
        segs.forEach(function (s, k) { if (s.key === key) idx.push(k); });
        var i = idx.length ? idx[Math.floor(Math.random() * idx.length)] : 0;
        var jitter = (Math.random() - 0.5) * step * 0.5;
        var turns = reduced ? 1 : 6;
        var F = jitter - i * step;
        while (F < cur + 360 * turns) F += 360;
        var dur = reduced ? 1400 : 6200;

        host.classList.remove('is-won');
        host.classList.add('is-spinning');
        setLights('spin');

        function finish() {
          rotorEl.style.transform = 'rotate(' + F + 'deg)';
          if (anim) anim.cancel();
          angle = ((F % 360) + 360) % 360;
          cancelAnimationFrame(raf);
          host.classList.remove('is-spinning');
          win(i);
          spinning = false;
          setTimeout(resolve, 1500);
        }

        if (!canAnimate) { var anim = null, raf = 0; finish(); return; }

        anim = rotorEl.animate([
          { transform: 'rotate(' + cur + 'deg)', easing: 'cubic-bezier(.45,0,.55,1)' },
          { transform: 'rotate(' + (cur - 14) + 'deg)', offset: .06, easing: 'cubic-bezier(.08,.55,.12,1)' },
          { transform: 'rotate(' + (F + 3.5) + 'deg)', offset: .93, easing: 'cubic-bezier(.45,0,.3,1)' },
          { transform: 'rotate(' + F + 'deg)' }
        ], { duration: dur, fill: 'forwards' });

        /* Pointeur qui « claque » à chaque séparation de case */
        var prevA = null, cum = 0, lastTick = null, raf = 0;
        (function loop() {
          var a = readAngle();
          if (prevA !== null) cum += ((a - prevA + 540) % 360) - 180;
          prevA = a;
          var t = Math.floor((cum + step / 2) / step);
          if (lastTick === null) lastTick = t;
          if (t !== lastTick) { lastTick = t; flick(); }
          raf = requestAnimationFrame(loop);
        })();

        anim.onfinish = finish;
      });
    }

    function reset() {
      host.classList.remove('is-won', 'is-spinning');
      winLayer.innerHTML = '';
      var g = host.querySelectorAll('.pw__seg');
      for (var k = 0; k < g.length; k++) g[k].classList.remove('is-win');
      setLights('idle');
      if (!idleAnim) startIdle();
    }

    setLights('idle');
    startIdle();
    return { spinTo: spinTo, reset: reset };
  }

  function confetti(host) {
    if (reduced || !host) return;
    var c = document.createElement('canvas');
    c.className = 'pw-confetti';
    var W = host.clientWidth, H = Math.max(host.clientHeight, 300);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = W * dpr; c.height = H * dpr;
    c.style.width = W + 'px'; c.style.height = H + 'px';
    c.style.top = (host.scrollTop || 0) + 'px';
    host.appendChild(c);
    var ctx = c.getContext('2d');
    if (!ctx) { c.remove(); return; }
    ctx.scale(dpr, dpr);
    var colors = ['#f5f5f5', '#ffffff', '#cfcfcf', '#bfa46a', '#8c8c8c'];
    var P = [];
    for (var i = 0; i < 150; i++) {
      var a = (-90 + (Math.random() - 0.5) * 120) * Math.PI / 180, sp = 5 + Math.random() * 10;
      P.push({ x: W / 2 + (Math.random() - 0.5) * 40, y: H * 0.3, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, w: 5 + Math.random() * 6, h: 3 + Math.random() * 5, r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.4, c: colors[i % colors.length] });
    }
    var t0 = null;
    function frame(now) {
      if (t0 === null) t0 = now;
      var t = (now - t0) / 1000;
      ctx.clearRect(0, 0, W, H);
      var alpha = Math.max(0, 1 - Math.max(0, t - 1.8) / 1.2);
      for (var k = 0; k < P.length; k++) {
        var p = P[k];
        p.vy += 0.3; p.vx *= 0.985; p.vy *= 0.985;
        p.x += p.vx; p.y += p.vy; p.r += p.vr;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.r);
        ctx.fillStyle = p.c;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, Math.max(1, p.h * Math.abs(Math.cos(p.r * 1.3))));
        ctx.restore();
      }
      if (t < 3) requestAnimationFrame(frame); else c.remove();
    }
    requestAnimationFrame(frame);
  }

  window.PashionWheel = { create: create, confetti: confetti };
})();